import { Box } from '@mui/material';
import SavePaymentInstrumentCheckbox from './fields/save-payment-instrument-checkbox.component';
import { SpreedlyDefault } from './spreedly-default.component';
import { Provider as SpreedlyFormProvider } from './spreedly-form.context';
import { useSpreedlyForm } from './spreedly-form.hooks';
import { SpreedlyToast } from './spreedly-toast.component';
import Form from 'components/form/form.component';
import IncButton from 'components/inc-button/inc-button.component';
import SpreedlyGlobalErrors from './spreedly-global-errors/spreedly-global-errors.component';
import { useTranslation } from 'react-i18next';

export const spreedlyNumberName = 'spreedly-card-number';
export const spreedlyCvvName = 'spreedly-cvv';
export const spreedlyIframeFields = {
  [spreedlyNumberName]: 'number',
  [spreedlyCvvName]: 'cvv',
};
export const spreedlyFieldsMap = {
  number: spreedlyNumberName,
  cvv: spreedlyCvvName,
};

const SpreedlyForm = ({
  formName,
  initOrderAttributes,
  onSuccess,
  onError,
  showSaveCardCheckbox,
  submit,
  button,
  disabled,
}) => {
  const { t } = useTranslation();
  const value = useSpreedlyForm(initOrderAttributes, onSuccess, onError);

  return (
    <Box data-testid="SpreedlyCard.Container">
      <Form
        onSubmit={e => {
          e.preventDefault();
          e.stopPropagation();
          submit();
        }}
        noValidate
        id="payment-form"
      >
        <SpreedlyFormProvider value={value}>
          <Box
            display="grid"
            rowGap={theme => theme.spacing(2)}
            sx={{
              '& .MuiInputLabel-root': {
                whiteSpace: 'nowrap',
              },
            }}
          >
            <SpreedlyFormSwitch formName={formName} />
            {showSaveCardCheckbox && <SavePaymentInstrumentCheckbox />}
          </Box>
        </SpreedlyFormProvider>
        {button && (
          <IncButton
            type="submit"
            data-testid="SpreedlyCard.CustomButton"
            fullWidth
            disabled={disabled}
          >
            {t('checkout.payment.spreedly.submit')}
          </IncButton>
        )}
        <SpreedlyGlobalErrors />
      </Form>
    </Box>
  );
};

export const SpreedlyFormSwitch = ({ formName }) => {
  switch (formName) {
    case 'spreedly':
    case 'spreedly_condenced_enhanced':
      return <SpreedlyDefault />;
    case 'toast_spreedly':
    case 'spreedly_enhanced':
    case 'toast_spreedly_canada':
    case 'spreedly_canada_enhanced':
      return <SpreedlyToast />;
    default:
      throw new Error('Spreedly Configuration Error - Unknown Form Name');
  }
};

export default SpreedlyForm;
